import { css } from "@emotion/react";
import { ChevronRight } from "lucide-react";
import { useProductDetailsState } from "../../hooks/useProductDetailsState";

//------------------------------------------------------------------------------------
//export type DepartmentCategorySubcategoryLinksProps = {};
export const DepartmentCategorySubcategoryLinks: React.FC /*<DepartmentCategorySubcategoryLinksProps>*/ =
	() => {
		const productDetailsState = useProductDetailsState();
		const product = productDetailsState.get().product;

		if (product !== undefined) {
			return (
				<div className="flex flex-wrap items-center justify-start gap-y-1 text-xs py-2 px-1">
					<span css={css`min-width:0;overflow-wrap:anywhere;`}>{product.WebCatalog ?? ""}</span>
					<ChevronRight className="shrink-0" size={12} />
					<span css={css`min-width:0;overflow-wrap:anywhere;`}>
						{product.InventoryDepartment ?? ""}
					</span>
					<ChevronRight className="shrink-0" size={12} />
					<span css={css`min-width:0;overflow-wrap:anywhere;`}>{product.Category ?? ""}</span>
					{product.SubCategoryId && (
						<>
							<ChevronRight className="shrink-0" size={12} />
							<span css={css`min-width:0;overflow-wrap:anywhere;`}>
								{product.SubCategory ?? ""}
							</span>
						</>
					)}
				</div>
			);
		}
		return null;
	};
